export enum EPaymentProvider {
  GLOBAL_PAYMENT = 0,
  WORLD_LINE = 1,
  ADYEN = 2,
  PAYPAL = 3,
  PRZELEWY24 = 4,
  KLARNA = 5,
  GOPAY = 6,
}
